import { ResearchAgreementStatus } from '../Types/interfaces';

export const BASE_PATH = 'dashboard';

// use this to prevent infinity rendering because empty array [] reference value always something else
export const EMPTY_ARRAY: any[] = [];

export const RESEARCH_AGREEMENT_STATUS_COLORS: Record<number, string> = {
  [ResearchAgreementStatus.Accepted]: 'green',
  [ResearchAgreementStatus.Rejected]: 'red',
  [ResearchAgreementStatus.Generated]: 'blue',
  [ResearchAgreementStatus.InReview]: 'orange',
  [ResearchAgreementStatus.Active]: 'lime',
};

export const RESEARCH_AGREEMENT_STATUS_LOCALE_KEYS: Record<number, string> = {
  [ResearchAgreementStatus.Accepted]: 'researchAgreementComp.statusAccepted',
  [ResearchAgreementStatus.Rejected]: 'researchAgreementComp.statusRejected',
  [ResearchAgreementStatus.Generated]: 'researchAgreementComp.statusGenerated',
  [ResearchAgreementStatus.InReview]: 'researchAgreementComp.statusInReview',
  [ResearchAgreementStatus.Active]: 'researchAgreementComp.statusActive',
};

export const DATE_FORMAT: Record<string, string> = {
  hu: 'YYYY.MM.DD',
  ro: 'DD.MM.YYYY',
  en: 'DD/MM/YYYY',
  de: 'DD.MM.YYYY',
};
